import React from "react";
import Carousel from "react-material-ui-carousel";
import { CircularProgress } from "@material-ui/core";

import { Card, CardContent, CardHeader, Typography, Tooltip, Box, Grid } from "@material-ui/core";
import { tooltips } from "../../constants/tooltips";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import { colours } from "../../utilities/styles";

const LeadershipFeedback = ({ effect_survey }) => {
  const feedback = [
    "say they have become more aware of their daily leadership behavior",
    "say they have become better leaders",
    "say they recommend Yomento to other leaders",
  ];

  const data = effect_survey.map((e) => {
    const { type, no_of_no, no_of_yes } = e;
    const sum = no_of_no + no_of_yes;
    if (sum < 3) {
      return { type, no_of_no: 0, no_of_yes: 1, ratio: "--" };
    }

    return {
      type,
      no_of_no,
      no_of_yes,
      ratio: `${Math.round((no_of_yes / sum) * 100)}%`,
      percent: Math.round((no_of_yes / sum) * 100),
      feedback,
    };
  });

  return (
    <Card>
      <CardHeader
        title={
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              padding: "8px 0 30px 20px",
            }}
          >
            <Typography variant="h6">What do the leaders say?</Typography>
            <Tooltip
              title={<Typography>{tooltips.leadershipFeedback}</Typography>}
              aria-label="effectsChart"
            >
              <HelpOutlineIcon />
            </Tooltip>
          </div>
        }
        style={{ padding: "8px 8px 0 0" }}
      />
      <CardContent>
        <Carousel>
          {data.map((e, index) => (
            <Grid container spacing={3}>
              <Grid item xs={6}>
                <Box position="relative" display="inline-flex">
                  <CircularProgress
                    disableShrink
                    variant="determinate"
                    value={e.percent}
                    size="225px"
                    style={{
                      color: colours.yomento_purple,
                    }}
                  />
                  <Box
                    top={90}
                    left={20}
                    bottom={0}
                    right={0}
                    position="absolute"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    height={50}
                  >
                    <Typography variant="h3" style={{ color: colours.yomento_purple }}>
                      {e.ratio !== "--" ? e.ratio : "0%"}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={6} style={{ maxHeight: "298px", minHeight: "298px" }}>
                <Box>
                  <Typography
                    variant="h6"
                    style={{
                      color: colours.yomento_purple,
                    }}
                  >
                    {e.ratio !== "--"
                      ? `${e.ratio} of your leaders...`
                      : "Awaiting user feedback..."}
                  </Typography>
                  <Typography
                    variant="h6"
                    style={{
                      color: colours.yomento_grey,
                      padding: "30px 0 148px 0",
                    }}
                  >
                    {e.feedback && e.feedback[index]}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          ))}
        </Carousel>
      </CardContent>
    </Card>
  );
};

LeadershipFeedback.propTypes = {};

export default LeadershipFeedback;
